import { BuildingSite } from '../../../domain/graphcms';
import { PropertyImage } from '../../../services/dtos/property';
import { AgentCardProps } from '../../components/agent-card/AgentCard';

export function getFeatures({ minDimension, minRooms, maxRooms }: BuildingSite | Omit<BuildingSite, 'agent'> & { agent: AgentCardProps }) {
  return [
    `da <strong>${minDimension}</strong> m²`,
    `<strong>${minRooms}</strong> - <strong>${maxRooms}</strong> locali`,
  ];
}

export function getGallery({ thumbnail, images }: BuildingSite | Omit<BuildingSite, 'agent'> & { agent: AgentCardProps }): PropertyImage[] {
  const cover = thumbnail ? [{
    large: thumbnail.image.url,
    medium: thumbnail.image.url,
    small: thumbnail.image.url,
    thumbnail: thumbnail.image.url,
    original: thumbnail.image.url,
  }] : [];

  return cover.concat(
    images.map((item) => ({
      large: item.image.url,
      medium: item.image.url,
      small: item.image.url,
      thumbnail: item.image.url,
      original: item.image.url,
    })),
  );
}
